/// <amd-module name="Environments/ProviderCreateDetails/VirtualMachines/Components/AddVirtualMachinesComponents" />
import * as React from "react";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { FormItem } from "VSSUI/FormItem";
import { ListSelection } from "VSSUI/List";
import { IListBoxItem } from "VSSUI/ListBox";
import { Dropdown } from "VSSUI/Dropdown";

import { EnvironmentBaseComponent, IEnvironmentBaseComponentState } from "Environments/EnvironmentsCommon/EnvironmentBaseComponent";
import { IResourceContributionProps, ResourceSectionTypes } from "Environments/EnvironmentsCommon/Utils";
import { IVirtualMachineProviderData } from "Environments/ProviderCreateDetails/VirtualMachines/Types";
import { VirtualMachinesProviderType, PageKey } from "Environments/ProviderCreateDetails/VirtualMachines/Utilities";


interface IAddVirtualMachineState extends IEnvironmentBaseComponentState {
    providerData: IVirtualMachineProviderData;
}

import * as Resources from "Environments/ProviderCreateDetails/VirtualMachines/Resources";
import { VirtualMachineGenericProviderComponent } from "Environments/ProviderCreateDetails/VirtualMachines/Components/VirtualMachineGenericProviderComponent";


export class AddVirtualMachinesComponent extends EnvironmentBaseComponent<IResourceContributionProps, IAddVirtualMachineState> {

    public getInstanceId(context?: IVssComponentContext): string {
        return "add-virtualmachines-instance-id";
    }

    constructor(props: IResourceContributionProps, context: IVssComponentContext) {
        super(props, context);
        let providerData: IVirtualMachineProviderData = {
            environmentName: this.props.environmentName || "",
            type: "GenericProvider",
            environmentId: this._getEnvironmentId()
        };

        this.state = {
            errorMessages: {},
            providerData: providerData
        };        
    }

    public render(): React.ReactNode {
        return <>
                <h2 className={this.props.headerClassName}>{Resources.VirtualMachineResourceLabel}</h2>
                <FormItem
                    label={Resources.ProviderLabel}
                    className={"flex-grow"}
                >
                { this.getErrorMessageView(PageKey.AddEnvironmentView) }
                { this.getErrorMessageView(PageKey.AgentPackageGet) }
                { this.getErrorMessageView(PageKey.AddEnvironmentPAT) }
                {
                    <Dropdown
                        items={this._getProviderTypes()}
                        onSelect={this._onProviderTypeChange}
                        selection={this._providerSelection}
                        className="vm-dropdown"
                        calloutContentClassName={"vm-dropdown-callout"}
                    />
                }
                </FormItem>
                {
                    this.state.providerData.type === VirtualMachinesProviderType.GenericProvider &&
                    <VirtualMachineGenericProviderComponent 
                        instanceId={this.getInstanceId()}
                        environmentName = { this.props.environmentName || "" }
                        environmentId = { this._getEnvironmentId() }
                    />
                }

            </>;
    }

    private _getEnvironmentId(): number {
        return this.props.environmentId as number | 0;
    }

    private _getProviderTypes(): IListBoxItem<{}>[] {
        const providerTypes =[
            { id: VirtualMachinesProviderType.GenericProvider, text: Resources.GenericProvider }
        ];
        
        return providerTypes
    }

    private _onProviderTypeChange = (event: any, selectedProvider: IListBoxItem<{}>) => {
        this.setState({
            providerData: {
                environmentName: this.props.environmentName || "",
                type: selectedProvider.id as "GenericProvider" | "",
                environmentId: this._getEnvironmentId()
            }
        });
    }

    // Remove selectedRange when few more provider types are added
    private _providerSelection = new ListSelection({ selectOnFocus: false, multiSelect: false, selectedRanges: [{beginIndex: 0, endIndex: 0}] });
}
VssComponent.register(ResourceSectionTypes.newVmProvider, AddVirtualMachinesComponent);